import {useContext} from 'react'

import PropTypes from 'prop-types'

import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import Context from '@s-ui/react-context'
import {useMediaQuery} from '@s-ui/react-hooks'
import {MoleculeTab, MoleculeTabs, moleculeTabsTypes, moleculeTabsVariants} from '@s-ui/react-molecule-tabs'
import {useRouter} from '@s-ui/react-router'
import {useMediaQueryBreakpoints} from '@adv-mt/mt-layout-render-media-query'
import IconCar from '@adv-mt/mt-svg-icons/lib/CarOutline'
import IconShop from '@adv-mt/mt-svg-icons/lib/ShopOutline'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

export const TAB_IDS = ['vehicles', 'dealers']
const BASE_CLASS = 'mt-UserFavorites-tabs'

const Tabs = ({selectedTabId, totalAds, totalDealers}) => {
  const {domain, i18n} = useContext(Context)
  const {push} = useRouter()
  const {track} = useAnalyticsTrack()

  const config = domain.get('config')
  const {PATHS} = config.get('paths')
  const {
    TRACKING_EVENT_NAMES: {FAVORITES_VEHICLES_TAB_CLICKED, FAVORITES_DEALER_TAB_CLICKED}
  } = config.get('tracking')

  const TAB_PATHS = {
    vehicles: PATHS.FAVORITES_LIST,
    dealers: PATHS.FAVORITES_LIST_DEALERS
  }

  const isMobile = !useMediaQuery(useMediaQueryBreakpoints.md)

  const handleChangeTab = (_, {numTab}) => {
    track({
      event: numTab === 1 ? FAVORITES_VEHICLES_TAB_CLICKED : FAVORITES_DEALER_TAB_CLICKED
    })

    const tabId = TAB_IDS[numTab - 1]
    push(TAB_PATHS[tabId])
  }

  return (
    <div className={BASE_CLASS}>
      <MoleculeTabs
        onChange={handleChangeTab}
        type={isMobile ? moleculeTabsTypes.FULLWIDTH : moleculeTabsTypes.HORIZONTAL}
        variant={moleculeTabsVariants.HIGHLIGHTED}
      >
        <MoleculeTab
          key={TAB_IDS[0]}
          label={`${i18n.t('COMMON.VEHICLES')} (${totalAds})`}
          active={selectedTabId === TAB_IDS[0]}
          icon={<IconCar size={ATOM_ICON_SIZES.medium} />}
        />
        <MoleculeTab
          key={TAB_IDS[1]}
          label={`${i18n.t('COMMON.SELLERS')} (${totalDealers})`}
          active={selectedTabId === TAB_IDS[1]}
          icon={<IconShop size={ATOM_ICON_SIZES.medium} />}
        />
      </MoleculeTabs>
    </div>
  )
}

Tabs.displayName = 'Tabs'
Tabs.propTypes = {
  selectedTabId: PropTypes.string,
  totalAds: PropTypes.number,
  totalDealers: PropTypes.number
}

export default Tabs
